export enum CompraEstado {
  IMPORTADO  = 'importado',   // Importado desde Marangatu — pendiente de revisión
  RECHAZADO  = 'rechazado',   // Rechazado por el usuario — no afecta stock/costos
  PENDIENTE  = 'pendiente',   // Confirmado, sin pago
  PAGADA     = 'pagada',      // Totalmente pagada
  PARCIAL    = 'parcial',     // Pago parcial
  ANULADA    = 'anulada',     // Anulada
}
